export default __webpack_public_path__ + "static/media/6-4.df95b707.png";